(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mh-installation-quote"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mh-installation-quote')) {
    customElements.define('mh-installation-quote', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const updateVariant = () => {
          const cart = document.getElementById(this.dataset.cartForm);
          const selected = cart && cart.querySelector('[name="id"]');
          const variantInput = this.querySelector('[data-quote-variant]');
          const skuInput = this.querySelector('[data-quote-sku]');
          if (!selected || !variantInput || !skuInput) return;
          const match = Array.from(this.querySelectorAll('[data-variant-id]')).find(item => item.dataset.variantId === selected.value);
          variantInput.value = selected.value;
          skuInput.value = match ? match.dataset.sku : '';
        };
        this.querySelector('details').addEventListener('toggle', updateVariant);
        this.querySelector('form').addEventListener('submit', updateVariant);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
